// extracted by mini-css-extract-plugin
module.exports = {"MediaLinks":"MediaLinks_MediaLinks__fDGH9","media":"MediaLinks_media__11b4r","emailSection":"MediaLinks_emailSection__-itwE","emailAddress":"MediaLinks_emailAddress__1Iyu0"};